import { useEffect, useState } from "react";
import { isTrackingEnabled } from "@/lib/trackingEnvironment";

const BLOCKED_COUNTRIES = new Set(["DK", "CN", "HK", "IS", "SG"]);
const COUNTRY_NAMES: Record<string, string> = {
  DK: "Danmark",
  CN: "Kina",
  HK: "Hongkong",
  IS: "Island",
  SG: "Singapore",
};

/**
 * Frontend geo-block check using Cloudflare's /cdn-cgi/trace endpoint.
 * Shows a banner and blocks content for visitors from restricted countries.
 */
export function GeoBlockCheck() {
  const [blocked, setBlocked] = useState(false);
  const [countryName, setCountryName] = useState("");

  useEffect(() => {
    if (!isTrackingEnabled()) return;

    async function check() {
      try {
        const res = await fetch("/cdn-cgi/trace");
        if (!res.ok) return;
        const text = await res.text();
        const match = text.match(/loc=(\w+)/);
        if (!match) return;
        const code = match[1].toUpperCase();
        if (BLOCKED_COUNTRIES.has(code)) {
          setBlocked(true);
          setCountryName(COUNTRY_NAMES[code] || code);
        }
      } catch {
        // Silently fail — don't block if we can't determine location
      }
    }
    check();
  }, []);

  if (!blocked) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-background">
      <div className="text-center p-8 max-w-md">
        <h1 className="text-2xl font-bold mb-4">Ej tillgänglig</h1>
        <p className="text-muted-foreground">
          Tyvärr är zooi.se inte tillgängligt i {countryName}. Vi levererar för närvarande
          endast inom Sverige.
        </p>
      </div>
    </div>
  );
}
